import { useTranslation } from 'react-i18next'
import { useDataContext } from '../contexts/DataContext'
import TempPassword from '../components/TempPassword'
import PrecautionIcon from '../images/precaution.svg'
import WarningIcon from '../images/warning.svg'
import Layout from './Layout'

const ScreensLegal = () => {
  const { t } = useTranslation()

  const { currentUserTemporaryPassword } = useDataContext()

  if (currentUserTemporaryPassword)
    return (
      <Layout>
        <TempPassword />
      </Layout>
    )

  return (
    <Layout>
      <h1>{t('legal.title')}</h1>
      <div className='legal'>

        <h2>
          {t('legal.legal_notice')}
        </h2>
        <p>{t('legal.legal_notice_text_1')}</p>

        <h2>
          {t('legal.confidentiality_notice')}
        </h2>
        <p>{t('legal.confidentiality_notice_text_1')}</p>

        <h2>
          {t('legal.warnings')}
          <img src={WarningIcon} alt='Icon' />
        </h2>

        <p>{t('legal.warnings_text_1')}</p>
        <p>{t('legal.warnings_text_2')}</p>

        <h2>
          {t('legal.precautions')}
          <img src={PrecautionIcon} alt='Icon' />
        </h2>

        <p>{t('legal.precautions_text1')}</p>
        <p>{t('legal.precautions_text2')}</p>
        <p>{t('legal.precautions_text3')}</p>
        <p>{t('legal.precautions_text4')}</p>
        <p>{t('legal.precautions_text5')}</p>
        <p>{t('legal.precautions_text6')}</p>
        <p>{t('legal.precautions_text7')}</p>
        <p>{t('legal.precautions_text8')}</p>
      </div>
    </Layout>
  )
}

export default ScreensLegal
